import React from 'react';
import { connect } from 'react-redux';
import { MainComponentBox, navTo, getFromTab,
  locationFallThrough } from '../../../../util/util.jsx';
import {
  tryToSaveDeal,
  tryToUpdateDeal,
  loadDeal,
  clearDealStore,
  clearLink,
  addDealEvent,
  editDealEvent,
  deleteDealEvent,
  addTransportExpenses,
  seTransportExpenses,
  updateDealField,
} from '../store/deal.store';
import {
  lockEntity,
  unlockEntity,
} from '../../../../store/collaboration';
import { storeFiles } from '../store/files.store';
import {
  Grid,
  Row,
  Form,
  Modal,
  Col,
  NavItem,
} from 'react-bootstrap';
import {
  Button,
  Checkbox,
} from '../../../form/FormControls.jsx';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();
import BaseDealEdit, { baseDealMapDispatchToProps, baseDealMapStateToProps }
  from '../BaseDealEdit.jsx';
import Files from '../files/Files.jsx';
import { handleFormChanged, setBulkExpensesConstructed } from '@/store/allaround.store.js';
import $ from 'jquery';
import { Map, List } from 'immutable';
import BulkVesselEdit from './bulkvessel/Edit';
import ContainerEdit from './container/Edit';
import RailEdit from './railcar/Edit';
import TruckEdit from './truck/Edit';
import DealHeader from '../DealHeader';
import vessel from '@/../style/vessel.png';
import container from '@/../style/container.png';
import railcar from '@/../style/railcar.png';
import truck from '@/../style/truck.png';
import Expenses from '../expenses/Edit.jsx';
import PaymentsContainer, { hasApprovedPayments } from '../payments/PaymentsContainer.jsx';
import AvailableSince, { VERSIONS } from '@/util/version';
import { dealOutstandingValue } from '@/component/blogic/deals/payments/PaymentsContainer.jsx';
import { putError } from '@/store/error.store';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import { divideBulkPaymentForTransport, filterBulkPayments,
  getBulkPaymentFiles } from '../expenses/ExpensesUtils';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import { calculateUnlinkedObject } from '../elements/BaseElement.jsx';
import ProfitLossTab from '../elements/ProfitLossTab';
import RoleConfigFilter from '@/component/auth/RoleConfigFilter.jsx';

class TransportEdit extends BaseDealEdit {
  constructor(props) {
    super(props);
    this.updateProduct = this.updateProduct.bind(this);
    this.constructBulkExpenses = this.constructBulkExpenses.bind(this);
    this.selectPayments = this.selectPayments.bind(this);

    this.selectTransport = this.selectTransport.bind(this);
    this.handleArchived = this.handleArchived.bind(this);
    this.openArchiveModal = this.openArchiveModal.bind(this);
    this.closeArchiveModal = this.closeArchiveModal.bind(this);
    this.archiveModalYesButton = this.archiveModalYesButton.bind(this);
    this.archiveTransport = this.archiveTransport.bind(this);
    this.getProductFromLink = this.getProductFromLink.bind(this);
    this.state = {
      product: '',
      productInit: false,
      name: undefined,
      tabSelected: getFromTab().endsWith('payments') ? 'payments' : 'deal',
    };
    this.bulkExpensesConstructed = false;
  }

  componentWillMount() {
    super.componentWillMount();
    this.initProduct(this.props);
    this.constructBulkExpenses();
    if (getFromTab().endsWith('payments') && this.state.tabSelected === undefined) {
      this.setState({ tabSelected: 'payments' });
    }
    if (this.props.params.dealId == 'new' &&
      !(this.props.dealCopy && this.props.dealCopy.get('transportType'))) {
      this.props.updateDealField('transportType', this.context.location.query.type || 'bulk');
    }
  }

  componentWillReceiveProps(props) {
    if (super.componentWillReceiveProps) {
      super.componentWillReceiveProps(props);
    }
    locationFallThrough(`Transport ${this.getNameString(props)}`,
      `/deals/transport/${props.params.dealId}`);
    this.constructBulkExpenses(props, this.props);

    this.initProduct(props);
    const name = this.getName(props);
    this.setState({
      products_forms_number: 0,
      link_forms_number: 0,
      name,
    });
  }

  shouldComponentUpdate(props) {
    if (props.lock != this.props.lock) {
      return false;
    }
    return true;
  }
  selectPayments() {
    this.setState({ tabSelected: 'payments' });
  }
  selectPL = () => {
    this.setState({ tabSelected: 'PL' });
  }
  selectTransport() {
    this.setState({ tabSelected: 'deal' });
  }
  constructBulkExpenses(props = this.props, oldProps) {
    const links = props.deal.get('links') ?
      props.deal.get('links') : undefined;

    if (links && props.transports && props.expensestypes &&
     (this.props.expensesRebuilded || !oldProps || oldProps.deal.get('links') != links ||
      props.transports != this.props.transports ||
      props.expensestypes != this.props.expensestypes ||
      (props.deal && oldProps.deal &&
        oldProps.deal.get('payments') != props.deal.get('payments')))) {
      // reset expensesToPreBulkState
      let currentExpenses = props.deal.get('expenses', new List());
      currentExpenses = currentExpenses.map(e => e.delete('actualWithBulk')
        .delete('isBulkExpenseWithoutBL')
        .set('bulkExpense', false));

      const bulkPayments = filterBulkPayments(props.deal.get('bulkPayments', new List()),
        'transport', props.expensestypes);
      let bulkExpenses =
       divideBulkPaymentForTransport(bulkPayments, props.deal.get('id'), props.transports);
      let mergedExpenseTypeIds = new Set();
      currentExpenses = currentExpenses.map((e) => {
        const bulkExpenseIdx = bulkExpenses.findIndex(be =>
          be.get('expensesType') == e.get('expensesType'));
        let newE = e;
        if (bulkExpenseIdx > -1) {
          const bulkExpense = bulkExpenses.get(bulkExpenseIdx);
          if (bulkExpense.get('isBulkExpenseWithoutBL')) {
            newE = e.set('summType', 'LS')
              .set('bulkExpense', true)
              .set('isBulkExpenseWithoutBL', true);
          } else {
            newE = e.set('summType', 'LS')
              .set('bulkExpense', true)
              .set('actualWithBulk', e.get('actualWithBulk', e.get('actual', 0))
              + (e.get('isDebit') == bulkExpense.get('isDebit') ?
                bulkExpense.get('actual') : -bulkExpense.get('actual')));
          }
          mergedExpenseTypeIds = mergedExpenseTypeIds.add(e.get('expensesType'));
        }
        return newE;
      });
      bulkExpenses = bulkExpenses.filter(
        be => !mergedExpenseTypeIds.has(be.get('expensesType')));
      currentExpenses = currentExpenses.concat(
        bulkExpenses.map(be => be
          .set('actualWithBulk', be.get('actual', 0))
          .set('actual', 0)
          .set('bulkExpense', true)));
      currentExpenses = currentExpenses.map((e) => {
        if (e.get('isBulkExpenseWithoutBL')) {
          return e.set('actualWithBulk', -1);
        }
        if (e.get('actualWithBulk') < 0) {
          return e.set('isDebit', !e.get('isDebit'))
            .set('actualWithBulk', Math.abs(e.get('actualWithBulk')));
        }
        return e;
      });
      this.props.setExpenses(currentExpenses);

      let files = new List();
      const uniqUUIDs = [];
      if (bulkPayments.size > 0) {
        files = getBulkPaymentFiles(bulkPayments.map(p => p.get('document')), files, uniqUUIDs);
        this.bulkExpensesConstructed = true;
      }
      if (files.size > 0 && !this.bulkExpenseFilesAdded) {
        this.bulkExpenseFilesAdded = true;
        this.props.storeFiles(files.toJS(), 'USUAL');
      }
      this.props.setBulkExpensesConstructed();
    }
  }

  getName(props) {
    let name;
    const data = props.deal;
    const dealFound = data && (data.get('id') || props.params.dealId == 'new');
    if (dealFound) {
      let type = 'bulk';
      if (data && data.get('transportType')) {
        type = data.get('transportType').toLowerCase();
      } else if (this.context && this.context.location &&
      this.context.location.query &&
      this.context.location.query.type) {
        type = this.context.location.query.type;
      }

      switch (type) {
        case 'bulk':
          name = data.get('vesselName');
          break;
        case 'railcar':
          name = data.get('vesselName');
          break;
        case 'truck':
          name = data.get('vesselName');
          break;
        case 'container':
          name = !data.get('transportNameVoyage') ? '' :
            data.get('transportNameVoyage').map((elem, idx) =>
              (elem.get('vesselName') || elem.get('voyageNumber') ?
                <span className="tag-alike" key={idx}>
                  {`${elem.get('vesselName') || ''} `}{elem.get('voyageNumber') || ' '}
                </span>
                : ''));
          break;
        default:
          break;
      }
    }
    return name;
  }

  getNameString(props) {
    let name;
    const data = props.deal;
    const dealFound = data && (data.get('id') || props.params.dealId == 'new');
    if (dealFound) {
      let type = 'bulk';
      if (data && data.get('transportType')) {
        type = data.get('transportType').toLowerCase();
      } else if (this.context && this.context.location &&
        this.context.location.query &&
        this.context.location.query.type) {
        type = this.context.location.query.type;
      }

      switch (type) {
        case 'bulk':
          name = data.get('vesselName');
          break;
        case 'railcar':
          name = data.get('vesselName');
          break;
        case 'truck':
          name = data.get('vesselName');
          break;
        case 'container':
          name = !data.get('transportNameVoyage') ? '' :
            data.get('transportNameVoyage').map((elem) =>  // eslint-disable-line
              elem.get('vesselName') || elem.get('voyageNumber') ?
                `${(elem.get('vesselName', '') || '')} ${elem.get('voyageNumber', ' ') || ' '}`
                : '');
          break;
        default:
          break;
      }
    }
    return name;
  }

  additionalAction(formData) {
    const links = this.props.deal.get('links') ?
      this.props.deal.get('links').toJS() : undefined;
    if (links) {
      links.forEach((link) => {
        const blQuantityControl = $(`#link${link.id}`)[0];
        if (blQuantityControl) {
          // eslint-disable-next-line
          link.billLandingQuantity = blQuantityControl.value;
        }
      });
      // eslint-disable-next-line
      formData.links = links;
    }
    if (this.props.transportNameVoyage) {
      // eslint-disable-next-line
      formData.transportNameVoyage = this.props.transportNameVoyage
    }
  }
  initProduct(props) {
    if ((props.deal.get('product') || props.deal.get('product') === 0)
     && !this.state.productInit) {
      this.setState({ product: props.deal.get('product'), productInit: true });
    }
  }

  updateProduct(value) {
    this.setState({ product: value ? value.product : '' });
  }

  validateSave(data) {
    if (document.getElementsByClassName('due-amount-invalid').length > 0) {
      this.props.putError({ alert: true,
        message: 'Excess multiple payment due amount' });
      return false;
    }

    const type = data.transportType || 'bulk';
    let name = '';
    switch (type.toLowerCase()) {
      case 'bulk':
      case 'railcar':
      case 'truck':
        name = data.vesselName;
        break;
      case 'container':
        if (data.transportNameVoyage) {
          data.transportNameVoyage.forEach((elem) => {
            name += elem.get ? elem.get('vesselName', '') : elem.vesselName;
          });
        }
        break;
      default:
        break;
    }
    if (!name || !name.trim()) {
      const dealHasApprovedPayments = hasApprovedPayments(data.payments);
      if (dealHasApprovedPayments) {
        this.props.putError({ alert: true,
          message: 'Vessel name is necessary because the deal has approved payments' });
        return false;
      }
    }

    const links = this.props.deal.get('links', new List());
    let blCheckResult = true;
    const blCheckError = (result) => {
      result && this.props.putError({ alert: true,  // eslint-disable-line
        message: 'There is not enough unlinked quantity in base deal.' });
    };
    links.forEach((l) => {
      const blq = l.get('billLandingQuantity');
      if (blq) {
        const purchaseProduct = this.props.purchases.find(p =>
          p.get('products', new List())
            .find(pr => pr.get('id') == l.get('purchaseProduct'), this, new Map()))
          .get('products', new List()).find(pr => pr.get('id') == l.get('purchaseProduct'));
        const saleProduct = this.props.sales.find(s =>
          s.get('products', new List())
            .find(pr => pr.get('id') == l.get('saleProduct')), this, new Map())
          .get('products', new List()).find(pr => pr.get('id') == l.get('saleProduct'));
        const updatedLinksListMapper = (sl) => {
          if (sl.get('id') == l.get('id')) {
            return l;
          }
          return sl;
        };
        if (purchaseProduct) {
          const purchaseLinks = purchaseProduct.get('purchaseLink', new List())
            .map(updatedLinksListMapper);
          if (calculateUnlinkedObject(purchaseProduct, purchaseLinks).quantityMax < 0) {
            blCheckError(blCheckResult);
            blCheckResult = false;
          }
        }
        if (saleProduct) {
          const saleLinks = saleProduct.get('saleLink', new List()).map(updatedLinksListMapper);
          if (calculateUnlinkedObject(saleProduct, saleLinks).quantityMax < 0) {
            blCheckError(blCheckResult);
            blCheckResult = false;
          }
        }
      }
    });
    return blCheckResult;
  }

  getProductFromLink(link, productType) {
    return this.props[`${productType}s`].find(p =>
      p.get('products', new List())
        .find(pr => pr.get('id') == link.get(`${productType}Product`)), this, new Map())
      .get('products', new List()).find(pr => pr.get('id') == link.get(`${productType}Product`),
        this, new Map());
  }

  handleArchived() {
    const links = this.props.deal.get('links');
    let hasLinkOutstanding = false;
    links && links.forEach((l) => {   //eslint-disable-line
      hasLinkOutstanding = hasLinkOutstanding ||
        !!dealOutstandingValue(this.getProductFromLink(l, 'purchase').get('payments', new List()));
      hasLinkOutstanding = hasLinkOutstanding ||
        !!dealOutstandingValue(this.getProductFromLink(l, 'sale').get('payments', new List()));
    });
    if ((hasLinkOutstanding || dealOutstandingValue(this.props.payments))
      && !this.props.deal.get('isArchived')) {
      this.openArchiveModal();
    } else {
      this.archiveTransport();
    }
  }

  archiveTransport() {
    this.props.updateDealField('isArchived', !this.props.deal.get('isArchived'));
    this.props.handleFormChanged();
  }

  openArchiveModal() {
    this.setState({ showArchiveModal: true });
  }
  closeArchiveModal() {
    this.setState({ showArchiveModal: false });
  }
  archiveModalYesButton() {
    this.archiveTransport();
    this.setState({ showArchiveModal: false });
  }

  render() {
    const data = this.props.deal;
    const dealFound = data && (data.get('id') || this.props.params.dealId == 'new');

    let component;

    if (dealFound) {
      let type = 'bulk';
      if (data && data.get('transportType')) {
        type = data.get('transportType').toLowerCase();
      } else if (this.context && this.context.location &&
      this.context.location.query &&
      this.context.location.query.type) {
        type = this.context.location.query.type;
      }
      let img = '';
      switch (type) {
        case 'bulk':
          img = <img src={vessel} alt="Bulk Vessel" className="transport-icon" />;
          break;
        case 'railcar':
          img = <img src={railcar} alt="Railcar" className="transport-icon" />;
          break;
        case 'truck':
          img = <img src={truck} alt="Truck" className="transport-icon" />;
          break;
        case 'container':
          img = <img src={container} alt="Contrainer ship" className="transport-icon" />;
          break;
        default:
          break;
      }

      const grayScreen =
      (<div
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          background: 'lightgray',
          opacity: '0.9',
          zIndex: '10',
          left: 0,
          display: this.state.hidden ? 'inherit' : 'none',
        }}
      />);
      const canEdit = validateRoleConfig(['myTransports#2', 'allTransports#2'], data);
      const canDelete = validateRoleConfig(['myTransports#3', 'allTransports#3'], data);
      const assignResponsibleAllowed = validateRoleConfig(['transportsAssignResponsible']);
      const locked = this.props.lock
        ? (this.props.lock.get('entityId') == data.get('id')
        && this.props.lock.get('ownerId') != this.props.currentUser) : false;
      const isReadonly = locked || !canEdit;
      const paymentsTab = [];
      paymentsTab.push(<NavItem
        onClick={this.selectPayments}
        className={`${this.state.tabSelected == 'payments' ? 'selected-deal' : 'unselected-deal'}`}
      ><div className={'transition-deal-button'}>Payments</div>
      </NavItem>);
      paymentsTab.push(
        <RoleConfigFilter permissions={['viewProfitability']}>
          <NavItem
            onClick={this.selectPL}
            className={`${this.state.tabSelected == 'PL' ? 'selected-deal' : 'unselected-deal'}`}
          ><div className={'transition-deal-button'}>Profit/Loss</div>
          </NavItem>
        </RoleConfigFilter>
      );
      const header = (<DealHeader
        name={<div>{img} {this.state.name}</div>}
        onNameClick={this.selectTransport}
        deal={data}
        id={data && data.get('id') ? data.get('id') : null}
        lock={this.props.lock}
        openModal={this.openModal}
        hidden={this.state.hidden}
        dealType="transport"
        cancel={this.handleCancelButton}
        onFromSubmitHandler={this.onFromSubmitHandler}
        allowDelete={canDelete}
        allowDuplicate={canEdit}
        disabled={locked || (!canEdit && !assignResponsibleAllowed)}
        nameClass={`${this.state.tabSelected == 'deal' ? 'selected-deal' : 'unselected-deal'}`}
        tabs={paymentsTab}
      />);

      component =
      (<MainComponentBox secondNavBar={header} withBreadcrumb wide>
        {this.renderKickOutInfo()}
        <Grid style={{ minHeight: 400, fontSize: 13 }} className={'container-wide'}>
          {grayScreen}
          <Col xs={12} className={'transport-edit-page'}>
            <Modal bsSize="small" show={this.state.showArchiveModal} onHide={this.closeModal} >
              <Modal.Body>
                Transport or one of its linked deals has outstanding payment.
                Do you really want to archive it?
              </Modal.Body>
              <Modal.Footer>
                <Button bsStyle="danger" onClick={this.archiveModalYesButton}>Yes</Button>
                <Button onClick={this.closeArchiveModal}>No</Button>
              </Modal.Footer>
            </Modal>
            {this.props.dealCopy ?
              <div />
              :
              <Form
                id="dealsForm" horizontal className="dealsForm"
                onChange={this.formChanged}
              >
                <DealEdit
                  data={data}
                  type={type}
                  payments={this.props.payments}
                  updateProduct={this.updateProduct}
                  product={this.state.product}
                  yesButton={this.yesButton}
                  closeModal={this.closeModal}
                  showModal={this.state.showModal}
                  hidden={this.state.hidden}
                  openModal={this.openModal}
                  cancel={this.props.cancel}
                  onFromSubmitHandler={this.onFromSubmitHandler}
                  dealAddEvent={this.dealAddEvent}
                  dealEditEvent={this.dealEditEvent}
                  deleteDealEvent={this.props.deleteDealEvent}
                  disabled={isReadonly}
                  locked={locked}
                  allowResponsiblesEdit={assignResponsibleAllowed}
                  isNew={this.props.params.dealId == 'new'}
                  tabSelected={this.state.tabSelected}
                  onArchive={this.handleArchived}
                />
                <Checkbox
                  name="hidden" id="hidden" ref="hidden" onChange={() => ({})}
                  checked={this.state.hidden} style={{ display: 'none' }}
                  disabled={isReadonly}
                />
              </Form>
            }
          </Col>
        </Grid>
        {this.bulkDuplicatesQuestion()}
      </MainComponentBox>);
    } else {
      component = <MainComponentBox wide />;
    }

    return component;
  }

  routerWillLeave(routeTo) {
    if (!validateRoleConfig(['myTransports#2', 'allTransports#2'], this.props.deal)) {
      return true;
    }
    return super.routerWillLeave(routeTo);
  }
}

const Edit = connect((state, props) => ({
  deal: state.getIn(['data', 'deals', 'deal'], new Map()),
  payments: state.getIn(['data', 'deals', 'deal', 'payments'], new List()),
  sales: state.getIn(['data', 'deals', 'list', 'sale'], new List()),
  purchases: state.getIn(['data', 'deals', 'list', 'purchase'], new List()),
  transports: state.getIn(['data', 'deals', 'list', 'transport']),
  lock: state.getIn(['data', 'locks', 'transport', props.params.dealId.toString()]),
  currentUser: Number(state.getIn(['session', 'id'])),
  type: 'transport',
  files: state.getIn(['data', 'deals', 'files']),
  formChanged: state.getIn(['allaround', 'formChanged']),
  vesselLoadingPorts: state.getIn(['data', 'deals', 'ports', 'vesselLoadingPorts'], new List()),
  vesselDischargePorts: state.getIn(['data', 'deals', 'ports', 'vesselDischargePorts'], new List()),
  transportNameVoyage:
  state.getIn(['data', 'deals', 'deal', 'transportNameVoyage']),
  autosaved: state.getIn(['allaround', 'autosaved']),
  loggedIn: state.getIn(['session', 'state']) == 'LOGGED_IN',
  expensestypes: state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List()),
  expensesRebuilded: state.getIn(['allaround', 'expensesRebuilded', 0], false),
  roles: state.getIn(['session', 'roles'], ''),
  ...baseDealMapStateToProps(state, props),
}),
(dispatch, props) => ({
  cancel() {
    const fromTab = getFromTab();
    if (fromTab) {
      navTo(`/deals/${fromTab}`);
      return;
    }
    navTo('/deals/transport');
  },
  tryToSave(formData, type, callGoBack, dontReload) {
    const fromTab = getFromTab();
    tryToSaveDeal(dispatch, formData, type, fromTab ? false : callGoBack, dontReload);
    if (fromTab && callGoBack) {
      navTo(`/deals/${fromTab}`);
    }
  },
  tryToUpdate(formData, type, id, callGoBack, dontReload) {
    const fromTab = getFromTab();
    tryToUpdateDeal(dispatch, formData, type, id, fromTab ? false : callGoBack, dontReload);
    if (fromTab && callGoBack) {
      navTo(`/deals/${fromTab}`);
    }
  },
  loadDeal(type, id) {
    loadDeal(dispatch, type, id);
  },
  clearDeal() {
    clearDealStore(dispatch, 'transport');
  },
  clearLink() {
    clearLink(dispatch);
  },
  storeFiles(files, type) {
    storeFiles(dispatch, files, type);
  },
  addDealEvent(event) {
    addDealEvent(dispatch, event);
  },
  deleteDealEvent(event) {
    deleteDealEvent(dispatch, event);
  },
  editDealEvent(oldEvent, newEvent) {
    editDealEvent(dispatch, oldEvent, newEvent);
  },
  lockEntity(entity) {
    lockEntity(dispatch, entity);
  },
  unlockEntity(entity) {
    unlockEntity(dispatch, entity);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
  putError(error) {
    putError(dispatch, error);
  },
  addExpenses(expenses) {
    addTransportExpenses(dispatch, expenses);
  },
  updateDealField(field, value) {
    updateDealField(dispatch, 'transport', field, value);
  },
  setBulkExpensesConstructed() {
    setBulkExpensesConstructed(dispatch, 0);
  },
  setExpenses(expenses) {
    seTransportExpenses(dispatch, expenses);
  },
  ...baseDealMapDispatchToProps(dispatch, { ...props, type: 'transport' }),
}))(TransportEdit);

// eslint-disable-next-line
export default class EditTransportComponent extends React.Component {

  render() {
    return (
      // eslint-disable-next-line
      <Edit key={this.props.params.dealId} {...this.props} />
    );
  }
}

const DealEdit = (props) => {
  let editComponent = <div />;
  let contractNumber = props.data ? props.data.get('vesselName', '') : '';
  switch (props.type) {
    case 'bulk':
      editComponent = <BulkVesselEdit {...props} />;
      break;
    case 'railcar':
      editComponent = <RailEdit {...props} />;
      break;
    case 'truck':
      editComponent = <TruckEdit {...props} />;
      break;
    case 'container': {
      let transportNameVoyage = props.data ? props.data.get('transportNameVoyage', []) : [];
      if (!Array.isArray(transportNameVoyage)) {
        transportNameVoyage = transportNameVoyage.toJS();
      }
      contractNumber = transportNameVoyage.map(tnv => tnv.vesselName).join('; ');
      editComponent = <ContainerEdit {...props} />; }
      break;
    default:
      break;
  }
  return (<div>
    <div style={{ display: props.tabSelected == 'deal' ? 'block' : 'none' }}>
      <Row>
        {editComponent}
      </Row>
      <Row style={{ display: 'flex' }}>
        <Col
          xs={6}
        >
          <Row className={'deal-documents-row'}>
            <Col
              xs={12}
              className={'deal-documents-label'}
            >
              Do you have a document?
            </Col>
            <Col xs={12}><Documents
              label="Documents" type="USUAL" disabled={props.disabled}
            />
            </Col>
          </Row>
        </Col>
        <Col
          xs={6}
        >
          <AvailableSince version={VERSIONS.Harmony}>
            <Expenses
              style={{ borderLeft: '1px #dfdfdf solid' }}
              prefix="transport"
              dealType="transport"
              hideFreightExpense
              disabled={props.disabled}
            />
          </AvailableSince>
        </Col>
      </Row>
    </div>
    <Row style={{ display: props.tabSelected == 'payments' ? 'block' : 'none' }}>
      <Col
        xs={12}
        style={{ marginTop: 25 }}
      >
        <AvailableSince version={VERSIONS.IphitoFinal}>
          <PaymentsContainer
            dealType="transport"
            contractNumber={contractNumber}
            vesselOwner={props.data.get('owner')}
            vesselBroker={props.data.get('vesselBroker')}
            forwarder={props.data.get('forwarder')}
            datchex={props.data.get('datex')}
            disabled={props.disabled}
          />
        </AvailableSince>
      </Col>
    </Row>
    {props.tabSelected == 'PL' &&
      <ProfitLossTab
        id={props.data.get('id')}
        isTransport
      />
    }

    <Modal bsSize="small" show={props.showModal} onHide={props.closeModal} >
      <Modal.Body>
        {`Are you sure you want to ${props.hidden ? 'restore' : 'delete'} transport?`}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button bsStyle="danger" onClick={props.yesButton}>Yes</Button>
          <Button onClick={props.closeModal}>No</Button>
        </div>

      </Modal.Footer>
    </Modal>
  </div>);
};

DealEdit.propTypes = {
  selectProduct: React.PropTypes.func,
  data: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  closeModal: React.PropTypes.func,
  openModal: React.PropTypes.func,
  yesButton: React.PropTypes.func,
  showModal: React.PropTypes.bool,
  hidden: React.PropTypes.bool,
  dealAddEvent: React.PropTypes.func,
  dealEditEvent: React.PropTypes.func,
  deleteDealEvent: React.PropTypes.func,
  cancel: React.PropTypes.func,
  onFromSubmitHandler: React.PropTypes.func,
  type: React.PropTypes.string,
  payments: React.PropTypes.object,
  tabSelected: React.PropTypes.string,
  locked: React.PropTypes.bool,
  allowResponsiblesEdit: React.PropTypes.bool,
};

const Documents = props =>
  <Files
    label={props.label} type={props.type} dealType="transport" disabled={props.disabled}
  />;

Documents.propTypes = {
  label: React.PropTypes.string,
  type: React.PropTypes.string,
  disabled: React.PropTypes.bool,
};
